import { ChangeDetectionStrategy, Component, Inject, Optional } from '@angular/core';
import * as R from 'ramda';

import { hasValue } from '../../util';
import { PcsErrorsToken } from './errors-token';

const getErrors: any = R.compose(
  R.map(R.last),
  R.toPairs
);

@Component({
  selector: 'pcs-errors',
  templateUrl: './errors.component.html',
  styleUrls: ['./errors.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ErrorsComponent {
  allErrors = null;

  constructor(@Optional() @Inject(PcsErrorsToken) private readonly errors: any) {
    this.allErrors = this.errors ? getErrors(this.errors) : null;
  }

  hasErrors() {
    return hasValue(this.allErrors);
  }

}
